





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator } from 'vee-validate';

import { getZipCode } from '@/api/resources/address';

import Input from '@/shared/components/Inputs/Input.vue';
import Field from '@/shared/components/Field/Field.vue';
import Modal from '@/shared/components/Modal/Modal.vue';

import Address from '@/classes/Address';

import Button from '@/shared/components/Button/Button.vue';

import AddressComponent from '@/shared/components/Address/Address.vue';
import BasicInfo from './BasicInfo.vue';

import { IAddress } from '@/interfaces/Address';
import { ICustomer } from '@/interfaces/Customer';
import { IZipCodeNotFound } from '@/interfaces/ZipCodeNotFound';

import { getValueIfIsNotNil } from '@/helpers/values';

const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Address: AddressComponent,
    BasicInfo,
    Button,
    Input,
    Field,
    Modal
  }
})
export default class CompleteRegister extends Vue {
  @Prop() private value: boolean;

  @Prop({
    default() {
      return new Validator();
    }
  })
  private validator: Validator;

  @CustomerModule.State(state => state.customer)
  private customer: ICustomer;

  @CustomerModule.Action('notFoundZipCode')
  private notFoundZipCode: (newCustomer: IZipCodeNotFound)=> void;

  @CustomerModule.State('isLoading')
  private isLoading: boolean;

  @CustomerModule.Action('completeRegister')
  private completeRegister!: (customer: ICustomer)=> void;

  private get missingBasicInfo() {
    return !this.customer.name || !this.customer.document;
  }

  private get hasAnyActiveAddress () {
    return this.customer.addresses
      && this.customer.addresses.some((address: any) => address && address.is_active);
  }

  private postalCode: string = '';
  private zipCodeLoading: boolean = false;

  private form = {
    address: new Address({
      street_name: '',
      street_number: '',
      city: '',
      neighborhood: '',
      state: '',
      postal_code: '',
      ibge_code: ''
    }),
    essencialInformation: {
      name: '',
      document: '',
    },
  } as any;

  public $refs!: {
    essentials: Vue;
    address: Vue;
  };

  private zipCodeNotFound(): void {
    this.form.address = {
      ...this.form.address,
      street_name: '',
      street_number: '',
      city: '',
      neighborhood: '',
      state: '',
      ibge_code: ''
    };
  }

  private validateForm() {
    return new Promise(async (resolve, reject) => {
      const result = await this.validator.validateAll(this.form.address);

      if (!this.form.address.zipCodeData) {
        if (this.form.address.postal_code.length >= 8) {
          this.validator.validate('postal_code', '0');
        } else {
          this.validator.validate('postal_code', this.form.address.postal_code.replace(/\D/g, ''));
        }
      }

      const essentials = this.$refs.essentials;
      const address = this.$refs.address;
      let element = null;

      this.$nextTick(() => {
        const firstField = Object.keys(this.validator.errors.collect())[0];
        if (firstField) {
          if (essentials.$refs.hasOwnProperty(firstField)) {
            element = essentials.$refs[firstField] as HTMLElement;
            element.focus();
          }

          if (address.$refs.hasOwnProperty(firstField)) {
            (address.$refs[firstField] as HTMLElement).focus();
          }
        }
      });
      result ? resolve() : reject();
    });
  }

  private async complete() {
    try {
      const customer = {
        ...this.customer,
        addresses: [this.form.address],
        ...(this.missingBasicInfo && this.form.essencialInformation),
      };

      await this.validateForm();
      await this.completeRegister(customer);

      this.$emit('input', true);
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }

  mounted () {
    if (this.hasAnyActiveAddress && !this.missingBasicInfo) {
      this.$emit('input', true);
    }
  }
}
